// Proxying compat shim for the `jquery` npm package.
// jQuery 4.0.0 removed several utility methods that were deprecated in 3.x.
// The admin dependency tree (activeadmin base.js, datetimepicker vendor) still
// calls these methods at runtime.  Patching them back onto the shared jQuery
// module instance is safe because webpack caches module exports, so every
// subsequent `require("jquery")` / ProvidePlugin injection sees the patches.
import $ from "jquery"

if (!$.isArray)    $.isArray    = Array.isArray
if (!$.isFunction) $.isFunction = fn => typeof fn === "function"
if (!$.parseJSON)  $.parseJSON  = JSON.parse
if (!$.type) {
  const class2type = {}
  "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ").forEach(n => {
    class2type[`[object ${n}]`] = n.toLowerCase()
  })
  $.type = obj => {
    if (obj == null) return String(obj)
    return class2type[Object.prototype.toString.call(obj)] || "object"
  }
}
if (!$.trim) $.trim = s => (s == null ? "" : String(s).trim())
if (!$.now)  $.now  = Date.now
